import { Typography, Button, Checkbox, FormControlLabel, FormGroup, Alert, TextField } from "@mui/material";
import Dropzone from "./Dropzone";
import { useState } from "react";
import axios from "axios";
import { HStack, VStack } from "Components";
import { store } from "static";
import { GPTQA_API_PATHS } from "./constants/api-paths";
import { FileUpload } from "@mui/icons-material";
import { Box } from "@mui/system";
import { backendConnector, DATA_LINK } from "connectors";
import { NotVoid } from "lodash";
interface IProps {
  onUpdate?: () => void;
  onUpload?: () => void;
  onQuitRefresh?: () => void;
}

export const PdfUploader = (props: IProps) => {
  const [uploadedFile, setUploadedFile] = useState<File>();
  const [fileName, setFileName] = useState<string>("");
  const [fileType, setFileType] = useState<string>("");
  const [ocr, setOcr] = useState(false);
  const [alert, setAlert] = useState<{ message: string; type: "success" | "error" | "info" }>();

  const handleUpload = async () => {
    if (!uploadedFile) {
      store.Alert("No files to import", "error");
      store.clearAsk();
      setAlert({ message: "No files to import", type: "error" });
    } else {
      setAlert({ message: "Uploading", type: "info" });

      if (props.onUpload) {
        props.onUpload();
      } else {
        try {
          const addOns = {
            ocr: ocr,
            filename: fileName,
            filetype: fileType,
          };
          const { Success } = await backendConnector.upload<string[]>(DATA_LINK.DMUpload, uploadedFile, addOns);
          if (!Success) {
            setAlert({ message: "Upload Failed", type: "error" });
            store.Alert("Document Add Failed", "error");
          }
          setAlert({ message: "Uploaded", type: "success" });
          store.Alert("Document Added Successfully", "success");
          if (props.onUpdate) props.onUpdate();
          if (props.onQuitRefresh) props.onQuitRefresh();
        } catch (e: any) {
          console.error(e);
          setAlert({ message: JSON.stringify(e?.message ?? e), type: "error" });
          store.Alert("Document Upload Failed", "error");
        }
      }
    }
  };
  const onDropError = (errorMsg: string) => {
    store.Alert("Please Check The File Type", "error");
    store.clearAsk();
  };

  const onDropFile = (acceptedFiles: any) => {
    const file = acceptedFiles["0"];
    console.log("onDropFile", file);

    const ftype = file.name.split(".").pop();
    const fname = file.name.split(".").slice(0, -1).join(".");

    setFileName(fname);
    setFileType(ftype);
    setUploadedFile(file);
  };

  const handleChangeFilename = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFileName(event.target.value);
  };

  return (
    <VStack width={"100%"} height="100%">
      <Typography fontWeight={"bold"}>Upload a file to Begin</Typography>
      <Dropzone accept={[".pdf", ".txt", ".doc", ".docx"]} onDrop={onDropFile} onError={onDropError} />
      <Typography fontSize={"0.5rem"} color={"grey"} fontStyle={"italic"}>
        *** The recommended file size is less than 10MB ***
      </Typography>
      {fileName && <TextField fullWidth label="Filename" onChange={handleChangeFilename} value={fileName} />}

      {/* <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={ocr}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setOcr(event.target.checked);
              }}
            />
          }
          label="Enhanced PDF Reader (OCR)"
        />
        {ocr && <Typography variant={"caption"}>This will take longer to process</Typography>}
      </FormGroup> */}

      {alert && (
        <Alert sx={{ width: "100%" }} severity={alert.type}>
          {alert.message}
        </Alert>
      )}

      <Box width={"100%"} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button disabled={!uploadedFile} variant={"outlined"} onClick={handleUpload} startIcon={<FileUpload />}>
          Upload
        </Button>
      </Box>
    </VStack>
  );
};
